export const COLOR_CHOICES = [
  '#F4511E',
  '#D81B60',
  '#8E24AA',
  '#5E35B1',
  '#3949AB',
  '#1E88E5',
  '#039BE5',
  '#00ACC1',
  '#00897B',
  '#7CB342',
  '#C0CA33',
  '#FDD835',
  '#FB8C00',
  '#6D4C41',
  '#FF7043',
  '#26A69A',
  '#AB47BC',
  '#BDBDBD',
];

export function pickForeground(color: string) {
  const hex = color.replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#111111' : '#ffffff';
}
